import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { Close, AdminPanelSettings } from '@mui/icons-material';
import AISettingsPanel from './AISettingsPanel';

interface AISettingsModalProps {
  open: boolean;
  onClose: () => void;
  isSuperAdmin: boolean;
  currentSearchProfile?: Record<string, unknown>;
}

const AISettingsModal: React.FC<AISettingsModalProps> = ({ open, onClose, isSuperAdmin, currentSearchProfile }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xl"
    fullWidth
    sx={{ '& .MuiDialog-paper': { height: '92vh' } }}
  >
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 6, color: '#283E56', fontWeight: 700 }}>
      <AdminPanelSettings sx={{ color: '#283E56' }} />
      AI Settings
      <IconButton onClick={onClose} sx={{ position: 'absolute', right: 12, top: 12 }} aria-label="Close">
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      <Box>
        <Typography variant="body2" sx={{ color: '#6B7280', mb: 2 }}>
          Changes here apply to all users when published or saved.
        </Typography>
        <AISettingsPanel isSuperAdmin={isSuperAdmin} currentSearchProfile={currentSearchProfile} />
      </Box>
    </DialogContent>
  </Dialog>
);

export default AISettingsModal;
